/**
 * AparienciaApiClient -- el logo y el fondo del negocio, guardados como ARCHIVO.
 *
 * Contrato medido el 17-sep en NexoAPI origin/main (AparienciaController + ReglasDeApariencia):
 *   POST /api/v1/apariencia/negocios/{businessId}/{tipo}   [RequireBusinessAccess]
 *        multipart/form-data, campo "archivo"; tipo = fondo | logo
 *        201 -> { success: true, data: { id, url, tipo, mime, bytes, sha256 } }
 *        400 -> { error: "<por que no se acepta>" }  (peso, formato por FIRMA, tipo)
 *   GET  /api/v1/apariencia/{id}  es publico y sirve la imagen con ETag.
 *
 * Lo que se guarda en la ficha del negocio es la URL que devuelve el API, nunca el archivo
 * en base64: un fondo en base64 se lleva por delante la fila de configuracion del negocio.
 *
 * @module infrastructure/api/AparienciaApiClient
 */

import { ApiBase } from './ApiBase.js';
import { porQueNoSePuedeSubir, urlDeLaSubida, idDeLaSubida } from '../../application/negocios/archivoDeApariencia.js';

const BASE = '/api/v1/apariencia/negocios';

export const AparienciaApiClient = {
  /**
   * Sube el archivo y devuelve la URL servida por el API. Nunca lanza.
   * @param {string} businessId
   * @param {'logo'|'fondo'} tipo
   * @param {File} archivo
   * @param {Uint8Array|null} primerosBytes los primeros 8 bytes, si el llamador ya los leyo
   */
  async subirArchivo(businessId, tipo, archivo, primerosBytes = null) {
    if (!businessId) return { ok: false, error: 'Elige primero el negocio.' };

    // Las reglas del API, repetidas aqui para no gastar el viaje (F5-bis: validar antes).
    const noSePuede = porQueNoSePuedeSubir(archivo, tipo, primerosBytes);
    if (noSePuede) return { ok: false, error: noSePuede, local: true };

    const cuerpo = new FormData();
    cuerpo.append('archivo', archivo, archivo.name || `${tipo}.png`);

    const res = await ApiBase.postArchivo(`${BASE}/${encodeURIComponent(businessId)}/${encodeURIComponent(tipo)}`, cuerpo);
    if (!res.ok) {
      return { ok: false, error: (typeof res.error === 'string' ? res.error : res.error?.message) || 'No pudimos subir la imagen.', code: res.code ?? null };
    }

    const url = urlDeLaSubida(res);
    if (!url) {
      // Un 201 sin URL no sirve para nada: la ficha guardaria un campo vacio.
      return { ok: false, error: 'El servidor guardo la imagen pero no devolvio su direccion.' };
    }
    return { ok: true, url, id: idDeLaSubida(res) };
  }
};
